import React from 'react';
import { Link } from 'react-router-dom';
import { Eye, Zap, Users, ShieldOff } from 'lucide-react';

const ScamWarning = ({ icon, title, children }) => (
    <div className="glass-card p-6 rounded-xl border border-red-500/30">
        <div className="flex items-center text-red-400 mb-3">
            {icon}
            <h3 className="ml-3 text-xl font-bold text-white">{title}</h3>
        </div>
        <p className="text-gray-300 leading-relaxed">{children}</p>
    </div>
);


export default function SpottingScamsPage() {
    return (
        <div className="space-y-8">
            <div className="text-center">
                <h1 className="text-4xl md:text-5xl font-black mb-4 bg-gradient-to-r from-red-500 to-yellow-500 bg-clip-text text-transparent">
                    How to Spot Cryptocurrency Scams
                </h1>
                <p className="text-lg text-gray-300 max-w-3xl mx-auto">
                    The crypto space is innovative, but also a target for bad actors. Learn these common red flags to protect your assets.
                </p>
            </div>

            <div className="grid md:grid-cols-1 lg:grid-cols-2 gap-6">
                <ScamWarning icon={<Zap size={24} />} title="Guaranteed High Returns">
                    If a project promises you can "100x your money" with no risk, it's almost certainly a scam. All legitimate investments carry risk.
                </ScamWarning>
                 <ScamWarning icon={<Users size={24} />} title="Anonymous or Fake Team">
                    If you can't find any information about the team, or if their profiles look fake (e.g., stock photos, no history), be extremely cautious.
                </ScamWarning>
                <ScamWarning icon={<Eye size={24} />} title="Pressure to Buy Urgently">
                    Scammers create a false sense of urgency (FOMO) with phrases like "presale ending soon!" or "limited spots available!" to rush you into a bad decision.
                </ScamWarning>
                <ScamWarning icon={<ShieldOff size={24} />} title="No Smart Contract Audit">
                    A reputable project will have its code audited by a third-party security firm to check for vulnerabilities. No audit is a major red flag.
                </ScamWarning>
                 <ScamWarning icon={<Eye size={24} />} title="Vague or Copied Whitepaper">
                   A professional project will have a detailed, well-written whitepaper. If it's full of buzzwords with no substance, or copied from another project, stay away.
                </ScamWarning>
                 <ScamWarning icon={<Users size={24} />} title="Fake Social Media Engagement">
                   Be wary of social media accounts with thousands of followers but very little real engagement (likes, comments). These are often bots designed to make a project seem more popular than it is.
                </ScamWarning>
            </div>

             <div className="text-center pt-6">
                <Link to="/learn" className="text-cyan-400 hover:text-cyan-300 font-semibold">
                    &larr; Back to All Learning Guides
                </Link>
            </div>
        </div>
    );
}